import {
  BaseEdge,
  EdgeLabelRenderer,
  type EdgeProps,
  getStraightPath,
} from "reactflow";
import type { MapViewEdge } from "@/lib/core/schemas/map-view";

export type PassageEdgeData = Pick<
  MapViewEdge,
  "kind" | "directionForward" | "directionReverse"
>;

export const PassageEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  data,
  markerEnd,
}: EdgeProps<PassageEdgeData>) => {
  const [path, labelX, labelY] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });
  const isBidirectional = data?.kind === "bidirectional-passage";

  return (
    <>
      <BaseEdge
        id={id}
        markerEnd={isBidirectional ? undefined : markerEnd}
        path={path}
        style={{ stroke: "#9ca3af", strokeWidth: 1.5 }}
      />
      <EdgeLabelRenderer>
        <div
          className="font-mono text-[9px] text-zinc-400"
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY - 8}px)`,
            pointerEvents: "none",
          }}
        >
          {data?.directionForward}
        </div>
        {isBidirectional && data?.directionReverse && (
          <div
            className="font-mono text-[9px] text-zinc-400"
            style={{
              position: "absolute",
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY + 10}px)`,
              pointerEvents: "none",
            }}
          >
            {data.directionReverse}
          </div>
        )}
      </EdgeLabelRenderer>
    </>
  );
};
